import React from 'react'
import { useSelector } from 'react-redux'

const MatildeBalloon = ({ children }) => {
    const avatar = useSelector(state => state.firebase.profile.avatar)
    const areMatildeNotifOn = useSelector(state => state.firebase.profile.matildeNotif)

    return !areMatildeNotifOn ? null :
        <div className='grid grid-cols-1 lg:grid-cols-12 items-center mb-10 lg:mb-16 gap-6 lg:gap-10'>
            <div className='text-center flex justify-center lg:col-span-2'>
                <img
                    alt='Matilde'
                    title='Matilde'
                    className='mb-6 h-32 lg:h-auto lg:mb-0 object-contain'
                    src={require(`../assets/img/matilde-faces/${avatar}.png`)}
                />
            </div>
            <div className='text-left lg:col-span-10'>
                <div className='bubble p-8'>
                    {children}
                </div>
            </div>
        </div>
}

export default MatildeBalloon
